import { jsx as _jsx } from "react/jsx-runtime";
import Spinner from 'reactstrap/es/Spinner';
import Api from '../Api';
import { BadgeUser, CompactBadgeUser } from '../../../Components/User/Badges/BadgeUser';
import { usePromise } from '../../../Utils/usePromise';
export function UserBadgeById({ userId, compact, type }) {
    const { isLoading, data: user, isError } = usePromise(() => Api.get(userId).then((res) => res.item));
    if (isLoading)
        return _jsx(Spinner, {});
    if (isError || !user)
        return null;
    if (compact) {
        return (_jsx(CompactBadgeUser, { _id: userId, avatar: user.avatar, email: user.email, fullName: user.fullName, registered: true, type: type }));
    }
    return (_jsx(BadgeUser, { registered: true, _id: userId, avatar: user.avatar, email: user.email, firstName: user.firstName, secondName: user.secondName, patronymic: user.patronymic, phone: user.phone }));
}
